import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/user': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M313.6 304c74.2 0 134.4 60.2 134.4 134.4v25.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-25.6c0-74.2 60.2-134.4 134.4-134.4 28.8 0 42.5 16 89.6 16s60.9-16 89.6-16zM400 464v-25.6c0-47.6-38.8-86.4-86.4-86.4-14.7 0-37.9 16-89.6 16-51.3 0-75-16-89.6-16-47.6 0-86.4 38.8-86.4 86.4v25.6h352zM224 288c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM224 48c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/user.js
// module id = 1832
// module chunks = 0